
// Export all language files
import { enTranslations } from './en';
import { noTranslations } from './no';
import { esTranslations } from './es';

// Combined translations object
export const landingTranslations = {
  en: enTranslations,
  no: noTranslations,
  es: esTranslations
};
